// extracted by mini-css-extract-plugin
module.exports = {"circle":"StepperCircle_circle__k5jrN","default":"StepperCircle_default__iXxUH","completed":"StepperCircle_completed__Wh_co","selected":"StepperCircle_selected__aixXg"};